// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentLayout_content__M63jw"};